import { prependMarketToPath } from 'common';
import { t } from 'i18n';
import { Environment, PassengerCounts, PassengerErrorType, TripType } from 'shared';

export const API_URL = import.meta.env.VITE_API_URL;

const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL ?? '';

if (!API_URL) {
  throw new Error('Environment variable API_URL missing');
}

export const Path = {
  FLIGHTS: `${prependMarketToPath(APP_BASE_URL)}/flights`,
  TRAVELERS: `${prependMarketToPath(APP_BASE_URL)}/travelers`,
  REVIEW: `${prependMarketToPath(APP_BASE_URL)}/review`,
};

export type PathValue = (typeof Path)[keyof typeof Path];

type NavLink = {
  path: string;
  label: string;
  testid: string;
};

export function getNavLinks(): NavLink[] {
  const config = {
    [Path.FLIGHTS]: {
      path: Path.FLIGHTS,
      label: t('nav.selectFlight'),
      testid: 'award nav select flight',
    },
    [Path.TRAVELERS]: {
      path: Path.TRAVELERS,
      label: t('nav.travelers'),
      testid: 'award nav travelers',
    },
    [Path.REVIEW]: {
      path: Path.REVIEW,
      label: t('nav.reviewBook'),
      testid: 'award nav select flight',
    },
  };

  return Object.values(config);
}

export const OUTBOUND_FLIGHTS_ID = 'award-outbound-flights';
export const INBOUND_FLIGHTS_ID = 'award-inbound-flights';

export const appConfig = {
  // local (dev) | test (staging) | production
  ENVIRONMENT: getEnvironment(import.meta.env.MODE),
  // App prefix path for the frontend

  // URL pointing to "manage my booking" page
  MMB_PATH: getEnvValue(import.meta.env.VITE_MMB_PATH, 'MMB_PATH'),

  // Sentry DSN for error logging in frontend only for now
  SENTRY_DSN: getEnvValue(import.meta.env.VITE_SENTRY_DSN, 'VITE_SENTRY_DSN'),

  // Source map release id for Sentry
  VITE_SOURCEMAP_RELEASE_ID: import.meta.env.VITE_SOURCEMAP_RELEASE_ID,
};

function getEnvironment(value: string | undefined) {
  if (typeof value === 'string') {
    const val = value as Environment;
    if (Object.values(Environment).includes(val)) {
      return val;
    }
  }

  throw new Error(`Missing environment variable ENVIRONMENT`);
}

function getEnvValue(value: string | undefined, key: string) {
  if (typeof value === 'string' && value) {
    return value;
  }

  throw new Error(`Missing environment variable ${key}`);
}

export enum CepError {
  FIELD_REQUIRED = 'cep-field-required',
}

export type CepErrors = {
  origin?: CepError;
  destination?: CepError;
  outboundDate?: CepError;
  inboundDate?: CepError;
  formError?: CepError | PassengerErrorType;
};

export type CepData = {
  origin?: string;
  destination?: string;
  tripType: TripType;
  outboundDate?: string;
  inboundDate?: string;
  passengerCounts: PassengerCounts;
};
